import { render } from "./HRModuleSection.vue?vue&type=template&id=bc757516&scoped=true"
import script from "./HRModuleSection.vue?vue&type=script&lang=js"
export * from "./HRModuleSection.vue?vue&type=script&lang=js"

import "./HRModuleSection.vue?vue&type=style&index=0&id=bc757516&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc757516"]])

export default __exports__